module.exports = __webpack_public_path__ + "static/HR Smartphone App AbaClik Meine Daten Dossier Lohnausweis-aefc66889bb5a22c618d2f53dce6a874.png";